// import jwt from "jsonwebtoken";

export default [
  {
    path: "/channel",
    name: "channel",
    component: () => import("@/views/channel/Channel.vue"),
    // beforeEnter: (to, from, next) => {
    //   const user = jwt.decode(localStorage.getItem("token"));
    //   if (user) {
    //     next();
    //   } else {
    //     next(false);
    //   }
    // },
    meta: {
      pageTitle: "channel",
      rule: "editor",
      authRequired: true,
    },
  },
  {
    path: "/joindiscussion",
    name: "joindiscussion",
    component: () => import("@/views/channel/components/JoinDisucssion.vue"),
    meta: {
      pageTitle: "Community",
      rule: "editor",
      authRequired: true,
    },
  },
  {
    path: "/pricing-details",
    name: "pricing",
    component: () => import("@/views/pricing/PricingDetails.vue"),
    meta: {
      pageTitle: "pricing",
      rule: "editor",
      authRequired: true,
    },
  },
];
